import { render, staticRenderFns } from "./InvoicePostDialog.vue?vue&type=template&id=2c3ff3c7"
import script from "./InvoicePostDialog.vue?vue&type=script&lang=js"
export * from "./InvoicePostDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports